<template>
  <div>
    <dialogos-app :dialogos="dialogos"></dialogos-app>
    <div class="text-xs-center">
      <svg-buttons @mostrar="textoActual = $event" @finished="$store.commit('nextShow', true)" />
      <v-layout justify-center>
        <v-flex xs12 md8>
          <transition name="custom" enter-active-class="animated fadeInUp faster" leave-active-class="animated fadeOutDown faster" mode="out-in">
            <p class="texto1 mt-4" :key="textoActual" v-if="textoActual>=0">
              <span v-html="textos[textoActual]"></span>
            </p>
          </transition>
        </v-flex>
      </v-layout>
    </div>
    
    <audio-player ref="audioPlayer" :autoplay="true" :audios="[
    'Modulo 1/AUDIO 07'
    ]"></audio-player> 
  </div>
</template>

<script>
import SvgButtons from '../../assets/Modulo 1/diapositiva-6'
export default {
  components: {
    SvgButtons
  },
  data() {
    return {
      dialogos: [
        "¿Y cuáles serían las consecuencias de esa sobreestimación? <span class='instruccion'>Haz clic en los iconos.</span>" 
      ],
      textos: [
        "Investigación por parte de la SEC – Securities and Exchange Commision.",
        "Destrucción de valor para los inversionistas y pérdida de confianza del mercado.",
        "Exponer a la empresa a una mala imagen en el sector y en general en el país.",
        "Tensión y estrés dentro de la organización.",
        "Despidos y reestructuraciones.",
        "Cierre de la empresa"
      ],
      textoActual: -1
    }
  },
  created() {
    this.$store.commit('nextShow', false)
  }
}
</script>
<style lang="scss" scoped>
</style>
